<template>
  <b-modal
    v-model="isVisible"
    size="md"
    :centered="true"
    :hide-header="true"
    :hide-footer="true"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    modal-class="nexos-invitation-modal"
    body-class="p-0"
    content-class="nexos-invitation-modal__content"
  >
    <div class="nexos-invitation-modal__inner">
      <button
        type="button"
        class="nexos-invitation-modal__close"
        :aria-label="$t('action.close')"
        @click="dismiss"
      >
        ×
      </button>
      <h3 class="nexos-invitation-modal__title">
        {{ $t('nexos.lab-invitation.title') }}
      </h3>
      <p
        class="nexos-invitation-modal__body"
        v-html="$t('nexos.lab-invitation.body')"
      />
      <b-button
        class="nexos-invitation-modal__cta"
        pill
        block
        @click="goToLab"
      >
        {{ $t('nexos.lab-invitation.cta') }}
      </b-button>
    </div>
  </b-modal>
</template>

<script>
const LAB_SLUG = 'lab-de-ideas';
const DISMISS_KEY = 'nexos.labIdeasInvitationDismissed';

export default {
  name: 'NexosNotificationModal',
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {
    isNexos() {
      return process.env.VUE_APP_CUSTOMER === 'nexos';
    },
    loggedUser() {
      return this.$store.getters.loggedUser;
    },
    isInvitedToLabDeIdeas() {
      return this.$store.getters.isInvitedToLabDeIdeas;
    },
    isOnLabRoute() {
      const slug = this.$route?.params?.communitySlug;
      if (slug === LAB_SLUG) return true;
      const path = this.$route?.fullPath || '';
      return path.includes(`/${LAB_SLUG}`);
    },
  },
  watch: {
    loggedUser: {
      handler() {
        this.evaluate();
      },
      immediate: true,
    },
    isInvitedToLabDeIdeas() {
      this.evaluate();
    },
    '$route.fullPath'() {
      this.evaluate();
    },
  },
  methods: {
    async evaluate() {
      if (!this.isNexos || !this.loggedUser?.key) {
        this.isVisible = false;
        return;
      }

      // Trigger the cached check (no-op if already resolved this session).
      await this.$store.dispatch('checkLabDeIdeasInvitation');

      if (sessionStorage.getItem(DISMISS_KEY) === '1') {
        this.isVisible = false;
        return;
      }

      if (this.isOnLabRoute) {
        this.isVisible = false;
        return;
      }

      this.isVisible = this.isInvitedToLabDeIdeas;
    },
    dismiss() {
      sessionStorage.setItem(DISMISS_KEY, '1');
      this.isVisible = false;
    },
    goToLab() {
      this.isVisible = false;
      window.location.href = `/${LAB_SLUG}`;
    },
  },
};
</script>

<style lang="scss">
/* b-modal is teleported to body — scope with modal root class */
.modal.nexos-invitation-modal .modal-content.nexos-invitation-modal__content {
  border: none;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}

.modal.nexos-invitation-modal .nexos-invitation-modal__inner {
  position: relative;
  background-color: #fdda24;
  color: #000;
  padding: 1.75rem 1.5rem 1.5rem;
  text-align: left;
}

.modal.nexos-invitation-modal .nexos-invitation-modal__close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  border: none;
  background: transparent;
  color: #000;
  font-size: 1.5rem;
  line-height: 1;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  font-weight: 300;

  &:hover {
    opacity: 0.7;
  }
}

.modal.nexos-invitation-modal .nexos-invitation-modal__title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #000;
  margin: 0 2rem 0.75rem 0;
  padding-right: 0.5rem;
}

.modal.nexos-invitation-modal .nexos-invitation-modal__body {
  font-size: 0.95rem;
  line-height: 1.45;
  color: #000;
  margin-bottom: 1.25rem;
}

.modal.nexos-invitation-modal .nexos-invitation-modal__cta {
  background-color: #fff !important;
  color: #000 !important;
  border: none !important;
  font-weight: 700;
  padding-top: 0.65rem;
  padding-bottom: 0.65rem;
}
</style>
